export default "__VITE_ASSET__6T67EueG__"